/**
 * @file コンポーネント：パスワード変更モーダル スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledModal = styled.div``;

export const StyledModalContent = styled.div`
    margin-bottom: 16px;

    &:last-of-type {
        margin-bottom: 0;
    }
`;

export const StyledModalLabel = styled.label`
    display: block;
    color: #000000;
    font-size: 16px;
    line-height: 24px;

    &::after {
        margin-left: 4px;
        color: #c31a1e;
        content: "*";
    }
`;
